export default "__VITE_ASSET__eNuKoW2V__"